import React from 'react';
import { SdfTabGroup, SdfTab, SdfBusyIndicator } from '@synerg/react-components';
import ProjectCredentials from './clientProjectCredentials';
import ClientScopes from './clientScopes';
import ApiPicker from '../apiDiscovery';

export default function ProjectSteps(props) {
	const {
		projectDetails,
		activeStep,
		setActiveStep,
		credValues,
		setCredValues,
		regenerateSIClientAppCreds,
		projectExists,
		loadingClientId,
		loadingClientSecret,
		carDetailsLoading,
		carDetails,
		fetchSIProjectDetails,
		scopeLastModified, events, subscribedEvents, filteredApis, apiPickerFetchProjectDetails
	} = props;

	const { clientOOID } = projectDetails;

	return (<div className="mt-10 flex">
		<div className="pr-8">
			<SdfTabGroup vertical={true} size="small">
				<SdfTab active={activeStep === 0} onClick={() => setActiveStep(0)}>
					Credentials
				</SdfTab>
				<SdfTab
					disabled={!projectExists ? true : undefined}
					active={activeStep === 1}
					onClick={() => projectExists ? setActiveStep(1) : ''}
				>
					Scope
				</SdfTab>
			</SdfTabGroup>
		</div>
		<div className="flex-1">
			{activeStep === 0 && <ProjectCredentials
				projectDetails={projectDetails}
				credValues={credValues}
				setCredValues={setCredValues}
				regenerateSIClientAppCreds={regenerateSIClientAppCreds}
				projectExists={projectExists}
				loadingClientId={loadingClientId}
				loadingClientSecret={loadingClientSecret}
				fetchSIProjectDetails={fetchSIProjectDetails}
				carDetails={carDetails}
				carDetailsLoading={carDetailsLoading}
			/>}
			{activeStep === 1 && (
				carDetailsLoading ? <SdfBusyIndicator overlay="true" size="lg" />
					:
					<ApiPicker
						isApiTab
						{...{
							projectDetails, filteredApis, scopeLastModified, apiPickerFetchProjectDetails,
							clientOOID, carDetails, subscribedEvents
						}}
					>
						<ClientScopes {...{ projectDetails, carDetailsLoading, filteredApis, events }} />
					</ApiPicker>
			)}
		</div>
	</div>);
}
